import React from 'react';
import SEO from '../components/SEO';

const PrivacyPolicy: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Politique de Confidentialité',
    description: 'Politique de confidentialité de BetSprinto',
  };

  return (
    <>
      <SEO
        title="Politique de Confidentialité - BetSprinto"
        description="Découvrez comment BetSprinto collecte, utilise et protège vos données personnelles."
        jsonLd={jsonLd}
      />

      <div className="min-h-screen pt-28 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Politique de <span className="text-gradient">Confidentialité</span>
          </h1>
          <p className="text-gray-400 mb-8">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

          <div className="glass rounded-2xl p-8 md:p-12 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
              <p className="text-gray-300 leading-relaxed">
                BetSprinto s'engage à protéger votre vie privée. Cette politique de confidentialité
                explique comment nous collectons, utilisons, stockons et protégeons vos données
                personnelles lorsque vous utilisez notre site web.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Données Collectées</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Nous collectons les types de données suivants :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Données de navigation (adresse IP, type de navigateur, pages visitées)</li>
                <li>Données de consentement (préférences cookies, vérification d'âge)</li>
                <li>Données techniques (résolution d'écran, système d'exploitation)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Utilisation des Données</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Nous utilisons vos données pour :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Améliorer votre expérience sur le site</li>
                <li>Analyser le trafic et l'utilisation du site</li>
                <li>Respecter nos obligations légales</li>
                <li>Personnaliser le contenu selon vos préférences</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Cookies</h2>
              <p className="text-gray-300 leading-relaxed">
                Notre site utilise des cookies pour améliorer votre expérience. Vous pouvez gérer
                vos préférences de cookies à tout moment. Pour plus d'informations, consultez notre{' '}
                <a href="/cookies" className="text-accent-primary hover:underline">
                  Politique des Cookies
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Partage des Données</h2>
              <p className="text-gray-300 leading-relaxed">
                Nous ne vendons jamais vos données personnelles. Nous pouvons partager des données
                agrégées et anonymisées avec nos partenaires pour améliorer nos services. Nous
                pouvons également divulguer des informations si la loi l'exige.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Sécurité</h2>
              <p className="text-gray-300 leading-relaxed">
                Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données
                contre tout accès non autorisé, altération, divulgation ou destruction.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Vos Droits</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Conformément au RGPD, vous avez le droit de :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Accéder à vos données personnelles</li>
                <li>Rectifier vos données</li>
                <li>Supprimer vos données</li>
                <li>Vous opposer au traitement de vos données</li>
                <li>Demander la portabilité de vos données</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Contact</h2>
              <p className="text-gray-300 leading-relaxed">
                Pour toute question concernant cette politique de confidentialité, contactez-nous
                à :{' '}
                <a href="mailto:contact@betsprinto.com" className="text-accent-primary hover:underline">
                  contact@betsprinto.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;

